<!DOCTYPE html>
<!--
  We disable Google Translate because it does not play well with React 16
  See https://github.com/facebook/react/issues/11538
-->
<html lang="en" class="notranslate">
  <head>
    <style>
      html {
        background-color: #f9f9f9;
      }
      html[data-mode='dark'] {
        background-color: #232323;
      }
      /* anti-flicker snippet for Google Optimize */
      .async-hide {
        opacity: 0 !important;
      }
    </style>
    <script>
      const theme = localStorage.getItem('__wb_theme') || 'light';
      if (theme === 'dark') {
        document.documentElement.classList.add('night-mode');
        // Used for tailwind dark mode
        document.documentElement.setAttribute('data-mode', 'dark');

        // The data attribute used by @wandb/components to toggle dark mode
        document.documentElement.setAttribute('data-dark-mode', 'true');
      } else {
        document.documentElement.classList.remove('night-mode');
        document.documentElement.removeAttribute('data-mode');

        document.documentElement.removeAttribute('data-dark-mode');
      }
    </script>

    <meta name="robots" content="max-image-preview:large" />
    <meta name="robots" content="noindex" />
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#000000" />
    <meta name="functions-insert-dynamic-og" />
    <meta name="functions-insert-dynamic-meta" />
    <meta name="referrer" content="no-referrer-when-downgrade" />

    <link rel="manifest" href="/manifest.json" />
    <!-- Sentry --->
    <script src="/raven.min.js" crossorigin="anonymous"></script>
    <!-- Prism syntax highlighting, TODO: just use what's in the bundle -->
    <script src="/prism.js"></script>
    <link type="text/css" rel="stylesheet" href="/prism.css" />
    <link rel="shortcut icon" type="image/png" href="/favicon.png" />
    <link rel="apple-touch-icon" href="/favicon.png" />
    <title>Weights &amp; Biases</title>
  </head>

  <script src="/env.js"></script>
  <body>
    <div id="root" style="height: 100%"></div>
    <script>
      window.Prism = window.Prism || {
        highlightAll: function () {},
      };
    </script>
    <script src="/consentAwareAnalyticsInjector.js"></script>
    <script type="module" src="/src/index.tsx"></script>
  </body>
</html>
